import React, {Component} from 'react';
import SearchBar from 'go/components/common/SearchBar';
import _ from 'lodash';
import {
  canViewTasksTab,
  canViewGrantsTab,
  canViewTeamTab,
  canViewTeamTabOld,
  canViewOrganizationsTab,
  canViewReportsTab,
  canViewPanelAdminTab,
  canViewAdminConsoleTab,
  canViewAdminConsoleTab2,
  hasGeneralPermission,
  canViewThingsToDo,
} from 'go/security/permissions';
import FEMAGoNowords from 'go/images/femago_small_color_trim.svg';
import {connect} from 'react-redux';
import REST from 'go/requests/rest';
import {allowAddSubapplication} from 'go/actions/checkAllowAddSubapplication';
import {Toggle} from 'componentLibrary';
import {
  Container,
  Dropdown,
  Grid,
  Icon,
  Image,
  Menu,
  Segment,
  SegmentGroup,
  Responsive,
} from 'semantic-ui-react';
import {push} from 'react-router-redux';
import {Link} from 'react-router-dom';
import {LOGOUT, SET_ORG_ID} from 'common/types';
import ApiActions from 'go/actions/api';
import Awareness from 'go/components/concurrency/awareness';

export class TopNav extends Component {
  navigateToMenuLink = (e, itemLink) => {
    const {setOrgId, defaultOrgId, navigateToMenuLink} = this.props;
    if (e.key === 'Enter') {
      navigateToMenuLink(itemLink);
    }
    setOrgId(defaultOrgId);
  };

  clickLogout = (e) => {
    if (e.key === 'Enter') {
      this.props.logout();
    }
  };

  options = [
    {
      key: 'Your profile',
      text: 'Your profile',
      title: 'Your profile',
      value: 'Your profile',
      as: Link,
      to: '/profile',
      onKeyDown: (e) => this.navigateToMenuLink(e, 'profile'),
    },
    {
      key: 'Log out',
      text: 'Log out',
      title: 'Log out',
      value: 'Log out',
      as: 'a',
      href: '#',
      onClick: this.props.logout,
      onKeyDown: this.clickLogout,
    },
  ];
  adminConsoleOptions = [
    {
      key: 'Workflow',
      text: 'Workflow',
      title: 'Workflow',
      value: 'Workflow',
      as: Link,
      to: '/admin/workflow',
    },
    {
      key: 'Pre-score',
      text: 'Pre-score',
      title: 'Pre-score',
      value: 'Pre-score',
      as: Link,
      to: '/admin/prescore',
    },
    {
      key: 'Whitelist',
      text: 'Whitelist',
      title: 'Whitelist',
      value: 'Whitelist',
      as: Link,
      to: '/admin/whitelist',
    },
  ];
  adminConsoleOptions2 = [
    {
      key: 'Create funding opportunity',
      text: 'Create funding opportunity',
      title: 'Create funding opportunity',
      value: 'Create funding opportunity',
      as: Link,
      to: '/initialize/fo',
      onKeyDown: (e) => this.navigateToMenuLink(e, 'initialize/fo'),
    },
  ];
  organizationsOptions = [
    {
      key: 'My organizations',
      text: 'My organizations',
      title: 'My organizations',
      value: 'My organizations',
      as: Link,
      to: '/organizationsPage',
      onKeyDown: (e) => this.navigateToMenuLink(e, 'organizationsPage'),
    },
    {
      key: 'My suborganizations',
      text: 'My suborganizations',
      title: 'My suborganizations',
      value: 'My suborganizations',
      as: Link,
      to: '/suborganizations',
      onKeyDown: (e) => this.navigateToMenuLink(e, 'suborganizations'),
    },
  ];
  grantsOptions = [
    {
      key: 'Manage my grants',
      text: 'Manage my grants',
      title: 'Manage my grants',
      value: 'Manage my grants',
      as: Link,
      to: '/grants',
      onKeyDown: (e) => this.navigateToMenuLink(e, 'grants'),
    },
    {
      key: 'Manage my suborganization grants',
      text: 'Manage my suborganization grants',
      title: 'Manage my suborganization grants',
      value: 'Manage my suborganization grants',
      as: Link,
      to: '/subgrants',
      onKeyDown: (e) => this.navigateToMenuLink(e, 'subgrants'),
    },
  ];

  componentDidMount() {
    const {token, postAllowedAddSubApp} = this.props;
    if (token) {
      return REST.organizationRelationship
        .getAllOrganizationProgramsUnrestricted(token)
        .then(REST.handler.handleResponse)
        .then((payload) => {
          const programs = payload.organizationPrograms;
          const ids = new Set(_.map(programs, 'programId'));
          const params = Array.from(ids).toString();
          return params
            ? REST.program.getProgramDetails(token, params)
            : Promise.reject('programId param is required');
        })
        .then(REST.handler.handleResponse)
        .then((payload) => {
          const isAllow = _.findIndex(payload, 'subapplicationFlag') >= 0;
          postAllowedAddSubApp(isAllow);
        })
        .catch((err) => {});
    }
  }

  render() {
    const {
      currentPath,
      currentUser,
      currUserEmail,
      permissions,
      allowAddSubapplicationInd,
      canHaveSubOrg,
      includeAwareness,
    } = this.props;

    const displayName =
      currentUser === 'undefined undefined' ? currUserEmail : currentUser;

    return (
      <React.Fragment>
        <Container id="topNav" fluid borderless="true" fixed="top">
          <SegmentGroup>
            <Segment basic inverted>
              <Container fluid>
                <Grid>
                  <Grid.Row>
                    <Grid.Column width={8} verticalAlign="middle">
                      <Link to="/" title="Home">
                        <Image
                          // size="small"
                          alt="FEMA Grants Outcomes"
                          className="logo"
                          inline
                          src={FEMAGoNowords}
                        />
                      </Link>
                      {permissions && (
                        <Menu pointing secondary text compact id="navbar">
                          {(canViewTasksTab(permissions) ||
                            hasGeneralPermission('TASKS_PAGE')) && (
                            <React.Fragment>
                              <div>
                                <Menu.Item
                                  as={Link}
                                  to="/tasks/"
                                  active={currentPath && currentPath.startsWith('/tasks')}
                                  title="Tasks"
                                >
                                  Tasks
                                </Menu.Item>
                              </div>
                            </React.Fragment>
                          )}

                          {canViewGrantsTab(permissions) && (
                            <React.Fragment>
                              <div>
                                <Menu.Item
                                  as={Link}
                                  to="/grants/"
                                  active={
                                    currentPath && currentPath.startsWith('/grants')
                                  }
                                  title="Grants"
                                >
                                  <Toggle toggle="!grantsDropdownRoute">Grants</Toggle>
                                  <Toggle toggle="grantsDropdownRoute">
                                    <Toggle toggle="!manageTeamOrgSubOrg">
                                      {allowAddSubapplicationInd ? (
                                        <Dropdown
                                          id="grants-dropdown"
                                          align="center"
                                          trigger={<span>Grants</span>}
                                          options={this.grantsOptions}
                                          onChange={(e, data) => {
                                            const option = _.find(this.grantsOptions, {
                                              key: data.value,
                                            });
                                            if (option) {
                                              option.onKeyDown(e);
                                            }
                                          }}
                                          simple
                                        />
                                      ) : (
                                        'Grants'
                                      )}
                                    </Toggle>
                                    <Toggle toggle="manageTeamOrgSubOrg">
                                      {canHaveSubOrg ? (
                                        <Dropdown
                                          id="grants-dropdown"
                                          align="center"
                                          trigger={<span>Grants</span>}
                                          options={this.grantsOptions}
                                          onChange={(e, data) => {
                                            const option = _.find(this.grantsOptions, {
                                              key: data.value,
                                            });
                                            if (option) {
                                              option.onKeyDown(e);
                                            }
                                          }}
                                          simple
                                        />
                                      ) : (
                                        'Grants'
                                      )}
                                    </Toggle>
                                  </Toggle>
                                </Menu.Item>
                              </div>
                            </React.Fragment>
                          )}
                          {(canViewTeamTab(permissions) ||
                            hasGeneralPermission('TEAM_MANAGEMENT')) && (
                            <div>
                              <Menu.Item
                                as={Link}
                                to="/team/"
                                active={currentPath && currentPath.startsWith('/team')}
                                title="Team"
                              >
                                Team
                              </Menu.Item>
                            </div>
                          )}
                          <Toggle toggle="subOrganizationRoute" ifNot>
                            {canViewTeamTabOld(permissions) && (
                              <div>
                                <Menu.Item
                                  as={Link}
                                  to="/team/"
                                  active={currentPath && currentPath.startsWith('/team')}
                                  title="Team"
                                >
                                  Team
                                </Menu.Item>
                              </div>
                            )}
                          </Toggle>
                          {canViewOrganizationsTab(permissions) && (
                            <Toggle toggle="subOrganizationRoute">
                              <React.Fragment>
                                <div>
                                  <Toggle toggle="!orgsDropdownRoute">
                                    <Toggle toggle="!manageTeamOrgSubOrg">
                                      <Menu.Item
                                        as={Link}
                                        to="/organizationsPage/"
                                        active={
                                          currentPath &&
                                          currentPath.startsWith('/organizationsPage')
                                        }
                                        title="Organizations"
                                      >
                                        Organizations
                                      </Menu.Item>
                                    </Toggle>
                                  </Toggle>
                                  <Toggle toggle="orgsDropdownRoute">
                                    <Toggle toggle="!manageTeamOrgSubOrg">
                                      <Menu.Item
                                        as={Link}
                                        to="/organizations/"
                                        active={
                                          currentPath &&
                                          currentPath.startsWith('/organizations/')
                                        }
                                        title="Organizations"
                                      >
                                        {allowAddSubapplicationInd ? (
                                          <Dropdown
                                            id="organizations-dropdown"
                                            align="center"
                                            trigger={<span>Organizations</span>}
                                            options={this.organizationsOptions}
                                            onChange={(e, data) => {
                                              const option = _.find(
                                                this.organizationsOptions,
                                                {
                                                  key: data.value,
                                                }
                                              );
                                              if (option) {
                                                option.onKeyDown(e);
                                              }
                                            }}
                                            simple
                                          />
                                        ) : (
                                          'Organizations'
                                        )}
                                      </Menu.Item>{' '}
                                    </Toggle>
                                    <Toggle toggle="manageTeamOrgSubOrg">
                                      <Menu.Item
                                        as={Link}
                                        to="/organizationsPage/"
                                        active={
                                          currentPath &&
                                          currentPath.startsWith('/organizationsPage/')
                                        }
                                        title="Organizations"
                                      >
                                        <Dropdown
                                          id="organizations-dropdown"
                                          align="center"
                                          trigger={<span>Organizations</span>}
                                          options={this.organizationsOptions}
                                          onChange={(e, data) => {
                                            const option = _.find(
                                              this.organizationsOptions,
                                              {
                                                key: data.value,
                                              }
                                            );
                                            if (option) {
                                              option.onKeyDown(e);
                                            }
                                          }}
                                          simple
                                        />
                                      </Menu.Item>{' '}
                                    </Toggle>
                                  </Toggle>
                                </div>
                              </React.Fragment>
                            </Toggle>
                          )}
                          <Toggle toggle="disasterSiteNav">
                            {canViewThingsToDo(permissions) && (
                              <div>
                                <Menu.Item
                                  as={Link}
                                  to="/thingsToDo/"
                                  active={
                                    currentPath && currentPath.startsWith('/thingsToDo')
                                  }
                                  title="Things to do"
                                >
                                  Things to do
                                </Menu.Item>
                              </div>
                            )}
                          </Toggle>
                          {(canViewReportsTab(permissions) ||
                            hasGeneralPermission('ANALYTICS')) && (
                            <Toggle toggle="analyticsRoute">
                              <Menu.Item
                                as={Link}
                                to="/analytics/"
                                active={
                                  currentPath && currentPath.startsWith('/analytics')
                                }
                                title="Reports"
                              >
                                Reports
                              </Menu.Item>
                            </Toggle>
                          )}
                          {canViewPanelAdminTab(permissions) && (
                            <Toggle toggle="panelAdmin">
                              <Menu.Item
                                id="admin-tab"
                                as={Link}
                                to="/panelReview/admin/sessions"
                                active={
                                  currentPath &&
                                  currentPath.startsWith('/panelReview/admin/sessions')
                                }
                                title="Panel Administration"
                              >
                                Panel Administration
                              </Menu.Item>
                            </Toggle>
                          )}
                          {canViewAdminConsoleTab(permissions) && (
                            <React.Fragment>
                              <div>
                                <Toggle toggle="adminConsole">
                                  <Menu.Item
                                    id="sys-admin-tab"
                                    as={Link}
                                    to="/sysadmin"
                                    active={
                                      currentPath && currentPath.startsWith('/sysadmin')
                                    }
                                    title="Administration"
                                  >
                                    <Dropdown
                                      id="system-admin-dropdown"
                                      align="center"
                                      trigger={<span>Administration</span>}
                                      options={this.adminConsoleOptions}
                                      simple
                                    />
                                  </Menu.Item>
                                </Toggle>
                              </div>
                            </React.Fragment>
                          )}
                          {canViewAdminConsoleTab2(permissions) && (
                            <React.Fragment>
                              <div>
                                <Toggle toggle="adminConsole2">
                                  <Menu.Item id="admin-tab" title="Administration">
                                    <Dropdown
                                      id="admin-dropdown"
                                      align="center"
                                      trigger={<span>Administration</span>}
                                      options={this.adminConsoleOptions2}
                                      onChange={(e, data) => {
                                        const option = _.find(this.adminConsoleOptions2, {
                                          key: data.value,
                                        });
                                        if (option) {
                                          option.onKeyDown(e);
                                        }
                                      }}
                                      simple
                                    />
                                  </Menu.Item>
                                </Toggle>
                              </div>
                            </React.Fragment>
                          )}
                        </Menu>
                      )}
                    </Grid.Column>
                    {permissions && (
                      <Grid.Column width={8} textAlign="right" verticalAlign="middle">
                        {includeAwareness && <Awareness />}
                        <Responsive as="span" minWidth={Responsive.onlyTablet.minWidth}>
                          <SearchBar />
                        </Responsive>

                        <Dropdown
                          className="profile"
                          align="center"
                          options={this.options}
                          onChange={(e, data) => {
                            const option = _.find(this.options, {
                              key: data.value,
                            });
                            if (option) {
                              option.onKeyDown(e);
                            }
                          }}
                          simple
                          trigger={
                            <span className="displayName">
                              <Icon
                                name="user"
                                content="test"
                                title="User Profile Icon"
                              />{' '}
                              {displayName}
                            </span>
                          }
                        />
                      </Grid.Column>
                    )}
                  </Grid.Row>
                </Grid>
              </Container>
            </Segment>
          </SegmentGroup>
        </Container>
      </React.Fragment>
    );
  }
}

export const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => {
      dispatch(ApiActions.auth.disableCookie());
      dispatch({type: LOGOUT});
    },
    navigateToMenuLink: (menuLink) => {
      dispatch(push(`/${menuLink}`));
    },
    setOrgId: (id) => {
      dispatch({type: SET_ORG_ID, payload: id});
    },
    postAllowedAddSubApp: (isAllow) => {
      dispatch(allowAddSubapplication(isAllow));
    },
  };
};
const getEntitiesInfo = (userEntitiesInfo) => {
  const canHaveSuborganizations =
    _.findIndex(userEntitiesInfo, 'canHaveSuborganizations') >= 0;
  return canHaveSuborganizations;
};

export const mapStateToProps = (state) => {
  return {
    token: state.auth.token,
    currentUser: state.profile.firstName + ' ' + state.profile.lastName,
    currUserEmail: state.profile.emailAdr,
    currentPath: state.router ? state.router.location.pathname : undefined,
    permissions: state.auth.permissions,
    allowAddSubapplicationInd: state.programAllowSubapplication.isAllow,
    canHaveSubOrg: getEntitiesInfo(state.userEntities.entitiesData),
    defaultOrgId: state.userSessionData.defaultOrgId,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TopNav);
